/* eslint-disable no-unused-expressions */
import React from 'react';
import ItemizedCard from '../../forms/itemizedCard';
import restApiClient from '../../services/restApiClient';
import CreateUpdateForm from '../createUpdateForm';
import { Container, Dialog } from './styles';

function CreateItemizedCardDialog({
  onSuccess,
  onError,
  onCancel,
  cashRegisterValueId,
  ...props
}) {
  return (
    <Container>
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick
        disableEscapeKeyDown
        {...props}
      >
        <CreateUpdateForm
          modelSchema={ItemizedCard}
          restGetDataById={restApiClient.itemizedCard.findById}
          restCreateData={restApiClient.itemizedCard.create}
          restUpdateData={restApiClient.itemizedCard.update}
          onCreateSuccess={(response) => {
            onSuccess?.({ ...response.data });
          }}
          onUpdateSuccess={(response) => {
            onSuccess?.({ ...response.data });
          }}
          onCancelClick={onCancel}
          modelData={{ cashRegisterValueId }}
          clearOnSuccess
          {...props}
        />
      </Dialog>
    </Container>
  );
}

export default CreateItemizedCardDialog;
